import { WarningFilled } from "@ant-design/icons";
import { useAuth0 } from "@auth0/auth0-react";
import { Typography } from "antd";
import ErrorView from "~components/Error";

const AuthErrorPage = () => {
  const { error, logout } = useAuth0();
  const handleLogout = () => logout({ logoutParams: { returnTo: window.location.origin } });

  return (
    <ErrorView
      titleIntlKey="error.auth"
      descriptionIntlKey="error.auth.description"
      actionButtonIntlKey="back.to.login"
      details={<Typography.Text>{error?.message}</Typography.Text>}
      Icon={WarningFilled}
      onActionButtonClick={handleLogout}
    />
  );
};

export default AuthErrorPage;
